import { FormControl, FormHelperText, TextField, styled } from "@mui/material";
import React, { useContext, useState } from "react";
import Select from "@common/components/Select";
import MenuItem from "@common/components/MenuItem";

import { TicketIssue } from "@services/tickets/types";
import { useTranslation } from "react-i18next";
import {
  CloseCaseTicketActionContext,
  CloseCaseTicketContext,
  ErrorIssueActionContext,
  ErrorIssueContext,
} from "../context";

export type IssueSourceState = {
  issueSource: string;
  issueSources: string[];
};

export type IssueResolutionState = {
  issueResolution: string;
  issueResolutions: string[];
};

const CloseCaseContent = () => {
  const { t } = useTranslation();

  const { errorIssueResolution, errorIssueSource } =
    useContext(ErrorIssueContext);
  const { setErrorIssueResolution, setErrorIssueSource } = useContext(
    ErrorIssueActionContext
  );

  const { resolution, source, comment } = useContext(CloseCaseTicketContext);
  const { setResolution, setSource, setComment, setIsFormModified } =
    useContext(CloseCaseTicketActionContext);

  const handleIssueChange = (value: string, field: keyof TicketIssue) => {
    setIsFormModified(true);
    if (field == "comment") setComment(value);
    else if (field == "source") {
      setErrorIssueSource("");
      setSource({
        issueSources: source.issueSources,
        issueSource: value,
      });
    } else if (field == "resolution") {
      setErrorIssueResolution("");
      setResolution({
        issueResolutions: resolution.issueResolutions,
        issueResolution: value,
      });
    }
  };

  return (
    <>
      <FormControl
        fullWidth
        sx={{
          py: 1,
        }}
      >
        <Select
          labelId="type-select-label"
          id="type-select"
          value={source?.issueSource}
          label={t("Source")}
          onChange={(e) =>
            handleIssueChange(e.target.value as string, "source")
          }
          required
        >
          {source?.issueSources
            ?.sort((a, b) => a.localeCompare(b))
            .map((type) => {
              return (
                <MenuItem key={`source_${type}`} value={type}>
                  {type}
                </MenuItem>
              );
            })}
        </Select>
        <FormHelperText error>{errorIssueSource}</FormHelperText>
      </FormControl>
      <FormControl
        fullWidth
        sx={{
          py: 1,
        }}
      >
        <Select
          required
          labelId="type-select-label"
          id="type-select"
          value={resolution?.issueResolution}
          label={t("Resolution")}
          onChange={(e) =>
            handleIssueChange(e.target.value as string, "resolution")
          }
        >
          {resolution?.issueResolutions
            ?.sort((a, b) => a.localeCompare(b))
            .map((type) => {
              return (
                <MenuItem key={`resolution_${type}`} value={type}>
                  {type}
                </MenuItem>
              );
            })}
        </Select>
        <FormHelperText error>{errorIssueResolution}</FormHelperText>
      </FormControl>
      <FormControl
        fullWidth
        sx={(theme) => ({
          py: 1,
          width: "100%",
          "& .MuiFormHelperText-root": {
            color: theme.palette.error.main,
          },
        })}
      >
        <TextField
          id="comments_multiline_textfield"
          label={t("Comments")}
          multiline
          value={comment}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            handleIssueChange(e.target.value, "comment")
          }
        />
      </FormControl>
    </>
  );
};

export default CloseCaseContent;
